import {fsa, fsaPayload} from './helpers'
import * as site from '../store/site'

// Page Change (initial page load and subsequent page changes)
// -----------

// used for checking authenticated state of users when they come direct or refresh the page
export const INITIAL_PAGE_LOAD = 'initial page load has occurred'
export const initialPageLoad = fsa(INITIAL_PAGE_LOAD)

export const INITIAL_PAGE_LOAD_NEW_SESSION = 'initial page load has occurred and its a new session'
export const initialPageLoadNewSession = fsa(INITIAL_PAGE_LOAD_NEW_SESSION)

export const INITIAL_PAGE_LOAD_EXISTING_SESSION =
  'initial page load has occurred and its an existing session'
export const initialPageLoadExistingSession = fsa(INITIAL_PAGE_LOAD_EXISTING_SESSION)

export const SUBSEQUENT_PAGE_LOAD = 'subsequent page load has occurred'
export const subsequentPageLoad = fsa(SUBSEQUENT_PAGE_LOAD)

export const WINDOW_ONLOAD = 'window onload has fired'
export const windowOnload = fsa(WINDOW_ONLOAD)

// URLs
// ----

export const DECANONICALIZE = 'decanonicalize the current page'
export const _decanonicalize = fsa(DECANONICALIZE)
export const decanonicalize = () => (dispatch, getState) =>
  !!site.canonicalHref(getState()) && dispatch(_decanonicalize())

export const CANONICALIZE = 'canonicalize the current page'
export const _canonicalize = fsaPayload(CANONICALIZE)
export const canonicalize = (_href) => (dispatch, getState) => {
  const state = getState()
  // if href is not set, set it to the current page minus search string
  const href = _href || `${window.location.origin}${window.location.pathname}`

  // if href is different from the current href, canonicalize the href
  if (site.canonicalHref(state) !== href) dispatch(_canonicalize(href))
}

// Footer
// ------

export const HIDE_FOOTER = 'hide the footer'
export const hideFooter = fsa(HIDE_FOOTER)

export const SHOW_FOOTER = 'show the footer'
export const showFooter = fsa(SHOW_FOOTER)

// Lock
// ----

export const ADD_LOCK = 'add lock to the window'
export const REMOVE_LOCK = 'remove lock from the window'

// Reset
// ----

export const RESET = 'reset the entire redux store'
export const reset = fsa(RESET)

// Toggle Min Nav Bar
// ----

export const DISABLE_MIN_NAV = 'disable the minimal nav bar'
export const disableMinNav = fsa(DISABLE_MIN_NAV)

export const ENABLE_MIN_NAV = 'enable the minimal nav bar'
export const enableMinNav = fsa(ENABLE_MIN_NAV)
